import { AxiosInstance } from "axios";
import { getBoardApiUrl } from "helpers";
import { MeetingFilterModel } from "Meetings/models/MeetingFilterModel";
import { MeetingDetailModel } from "models/MeetingDetailModel";
import { PaginatedList } from "models/PaginatedList";

export class MeetingsApi {
  constructor(private axios: AxiosInstance) {}

  async getDetails(signal?: AbortSignal) {
    const url = getBoardApiUrl("");
    const response = await this.axios.get<PaginatedList<MeetingDetailModel>>(url, { signal });
    return response.data;
  }

  async getDetailsPaged(filters: MeetingFilterModel, signal: AbortSignal): Promise<PaginatedList<MeetingDetailModel>> {
    const url = getBoardApiUrl(`meetings/detailed`);
    const response = await this.axios.post<PaginatedList<MeetingDetailModel>>(url, filters, { signal });
    return response.data;
  }
}
